import React from "react";
import { ProductConsumer } from "../../context";
import styled from "styled-components";


export default function CartDeliveryChoice() {
	return (
		<div className="container">
			<div className="row">
				<ProductConsumer>
					{(value) => {
						const { deliveryOption, handleChangeDelivery} = value;
						return (
							<div className="row my-1 mx-auto">
							<DeliveryChoiceWrapper>
							<div className="d-flex text-title text-center">
							<div className="mx-4">
							<p>Vælg leverings metode</p>
							</div>
							<div>
								<select
										name="DeliveryOption"
										id="deliveryOption"
										className="filter-item"
										onChange={handleChangeDelivery}
										value={deliveryOption}
									>	
												<option value="Hent selv">
													Hent selv
												</option>
												<option value="Udbringning">
													Udbringning
												</option>
										
									</select>
									</div>
							
									</div>
							</DeliveryChoiceWrapper>
						
							</div>

						);
					}}
				</ProductConsumer>
			</div>
		</div>
	);
}
const DeliveryChoiceWrapper = styled.div`
	width:100%;
	

	.filter-item
	{
		display: block;
		width: 100%;
		background: transparent;
		border-radius: 0.5rem;
		border: 2px solid var(--darkGrey);
	}
`;